import React from "react";
import { Chip, Menu, MenuItem } from "@mui/material";

const QuestionType = ({ label }) => {
  const [anchor, setAnchor] = React.useState(null);
  const open = Boolean(anchor);

  const handleClick = (e) => {

    if (e.target.innerText === label) {
        setAnchor(null)
    } else {
        console.log(e.target.innerText);
        setAnchor(null);
    }

  }

  return (
    <>
      <Chip label={label} style={{ cursor: "pointer" }} onClick={(e) => setAnchor(e.currentTarget)}/>
      <Menu
        anchorEl={anchor}
        open={open}
        onClose={() => setAnchor(null)}
      >
        <MenuItem onClick={handleClick}>YesNo</MenuItem>
        <MenuItem onClick={handleClick}>Choice</MenuItem>
        <MenuItem onClick={handleClick}>Range</MenuItem>
        <MenuItem onClick={handleClick}>Text</MenuItem>

      </Menu>
    </>
  );
};

export default QuestionType;
